import { useEffect, useRef, useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

interface RedirectionModalBodyProps {
  close: ({ navigate }: { navigate: NavigateFunction }) => void;
  title: string;
  timeToRedirect: number;
  setExtraParams: ({ navigate }: { navigate: NavigateFunction }) => void;
}

export function RedirectionModalBody({
  title,
  timeToRedirect,
  close,
  setExtraParams
}: RedirectionModalBodyProps) {
  const timerInterval = useRef<number | null | NodeJS.Timeout>(null);

  const [timer, setTimer] = useState(timeToRedirect);
  const navigate = useNavigate();

  useEffect(() => {
    timerInterval.current = setInterval(() => {
      setTimer(prev => prev - 1);
    }, 1000);
  }, []);

  useEffect(() => {
    setExtraParams({ navigate });
  }, []);

  useEffect(() => {
    if (timer === 0) {
      close({ navigate });
      clearInterval(timerInterval.current as number);
    }
  }, [timer]);
  return (
    <div className='center-flex-col'>
      <div className='text-body-1 text-secondary'>{title}</div>
      <div className='text-subheading-2 text-secondary'>{timer}</div>
    </div>
  );
}
